import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { ControlContainer, FormGroup } from '@angular/forms';

@Component({
  selector: 'format-time',
  templateUrl: './format-time.component.html',
  styleUrls: ['./format-time.component.scss']
})
export class FormatTimeComponent implements OnInit {
  @Input() controlName!: string;        // Girdi adı (Örn: 'starttime', 'endtime', 'times')
  @Input() label: string = 'Saat';      // Başlık yazısı
  @Input() required: boolean = false;   // Zorunlu mu?
  @Input() disabled: boolean = false;   // Engelli mi?

  // Tetiklenecek fonksiyonlar için dışa aktarma (Event Emitters)
  @Output() timeBlur = new EventEmitter<any>();
  @Output() timeChange = new EventEmitter<any>();

  // Saat maskesi konfigürasyonu (Eski sayfadaki maskTime buraya gömüldü)
  public maskConfig = {
    mask: [/[0-2]/, /[0-9]/, ':', /[0-5]/, /[0-9]/],
    guide: false
  };

  constructor(private controlContainer: ControlContainer) {}

  ngOnInit() {}

  // Ana ekrandaki formu otomatik bulup yakalayan akıllı getter
  get parentForm(): FormGroup {
    return this.controlContainer.control as FormGroup;
  }

  onBlurEvent() {
    this.timeBlur.emit();
  }

  onChangeEvent() {
    this.timeChange.emit();
  }
}
